import { useState } from "react";
import { Moon, Sun } from "lucide-react";
import { getTheme, setTheme } from "@/lib/theme";

export default function ThemeToggle() {
  const [mode, setMode] = useState(getTheme());
  const toggle = () => { const m = mode === "dark" ? "light" : "dark"; setTheme(m); setMode(m); };
  return (
    <button onClick={toggle} data-testid="theme-toggle"
      title={mode === "dark" ? "Switch to Light Mode" : "Switch to Night Mode"}
      className="w-full h-10 rounded-lg flex items-center justify-center gap-2 font-semibold text-sm text-zinc-600 hover:bg-zinc-100 transition active:scale-[0.98]">
      {mode === "dark" ? <Sun size={17} /> : <Moon size={17} />} {mode === "dark" ? "Light Mode" : "Night Mode"}
    </button>
  );
}
